import Vue from 'vue'

const accordionMixin = {
  data() {
    return {
      columnAttributesVerified: [],
      requestMatchesAccordion: {},
      currentRequestAccordion: [],
      columnAttributes: [],
      attributeKeys: [],
      valuesInsert: [],
    }
  },
  computed: {
    verifiedAttributesAccordion: function () {
      return [
        { solicitud_id: 'Id', order: 1 },
        { solicitada: 'Solicitada', order: 2 },
        { estado_material: 'Estado', order: 3 },
        { proyecto: 'Proyecto', order: 4 },
        { tipo_solicitud: 'Tipo', order: 5 },
        { contrato: 'Job', order: 6 },
        { cuenta_contable: 'Cta. Cont.', order: 7 },
        { fecha: 'Fecha', order: 8 },
        { contratista: 'Proveedor', order: 9 },
        { total_solicitud: 'Total solicitud', order: 10 },

        { verificado_detalle_texto: 'Detalle(Texto)', order: 11 },
        { verificado_detalle_numero: 'Detalle(Número)', order: 12 },
        { verificado_material_descripcion_material_texto: 'Material(Texto)', order: 13 },
        { verificado_material_monto_material_monto: 'Material(Plata)', order: 14 },
        { verificado_material_descripcion_material_texto2: 'Material Detalle(Texto)', order: 15 },
        { verificado_material_monto_material_monto2: 'Material Detalle(Plata)', order: 16 },

        { verificado_material_descripcion_mano_de_obra_texto: 'Material Mano de Obra(Texto)', order: 17 },
        { verificado_material_monto_mano_de_obra_monto: 'Material Mano de Obra(Plata)', order: 18 },
        { verificado_material_descripcion_mano_de_obra_texto2: 'Material Mano de Obra Det.(Texto)', order: 19 },
        { verificado_material_monto_mano_de_obra_monto2: 'Material Mano de Obra Det.(Plata)', order: 20 },

        { verificado_material_descripcion_equipo_texto: 'Material Equipo(Texto)', order: 21 },
        { verificado_material_monto_equipo_monto: 'Material Equipo(Plata)', order: 22 },
        { verificado_material_descripcion_equipo_texto2: 'Material Equipo Detalle(Plata)', order: 23 },
        { verificado_material_monto_equipo_monto2: 'Material Equipo Detalle(Plata)', order: 24 },

        { verificado_mano_de_obra_descripcion_material_texto: 'Mano de Obra Materia(Texto)', order: 25 },
        { verificado_mano_de_obra_monto_material_monto: 'Mano de Obra Material(Plata)', order: 26 },
        { verificado_mano_de_obra_descripcion_material_texto2: 'Mano de Obra Material Det.(Texto)', order: 27 },
        { verificado_mano_de_obra_monto_material_monto2: 'Mano de Obra Material Det.(Plata)', order: 28 },

        { verificado_mano_de_obra_descripcion_mano_de_obra_texto: 'Mano de Obra(Texto)', order: 29 },
        { verificado_mano_de_obra_monto_mano_de_obra_monto: 'Mano de Obra(Plata)', order: 30 },
        { verificado_mano_de_obra_descripcion_mano_de_obra_texto2: 'Mano de Obra Detalle(Texto)', order: 31 },
        { verificado_mano_de_obra_monto_mano_de_obra_monto2: 'Mano de Obra Detalle(Plata)', order: 32 },

        { verificado_mano_de_obra_descripcion_quipo_texto: 'Mano de Obra Equipo(Texto)', order: 33 },
        { verificado_mano_de_obra_monto_equipo_monto: 'Mano de Obra Equipo(Plata)', order: 34 },
        { verificado_mano_de_obra_descripcion_quipo_texto2: 'Mano de Obra Equipo Det.(Texto)', order: 35 },
        { verificado_mano_de_obra_monto_equipo_monto2: 'Mano de Obra Equipo Det.(Plata)', order: 36 },

        { verificado_equipo_descripcion_material_texto: 'Equipo Material(Texto)', order: 37 },
        { verificado_equipo_monto_material_monto: 'Equipo Material(Plata)', order: 38 },
        { verificado_equipo_descripcion_material_texto2: 'Equipo Material Detalle(Texto)', order: 39 },
        { verificado_equipo_monto_material_monto2: 'Equipo Material Detalle(Plata)', order: 40 },

        { verificado_equipo_descripcion_mano_de_obra_texto: 'Equipo Mano de Obra(Texto)', order: 41 },
        { verificado_equipo_monto_mano_de_obra_monto: 'Equipo Mano de Obra(Plata)', order: 42 },
        { verificado_equipo_descripcion_mano_de_obra_texto2: 'Equipo Mano de Obra Det.(Texto)', order: 43 },
        { verificado_equipo_monto_mano_de_obra_monto2: 'Equipo Mano de Obra Det.(Plata)', order: 44 },

        { verificado_equipo_descripcion_quipo_texto: 'Equipo(Texto)', order: 45 },
        { verificado_equipo_monto_quipo_monto: 'Equipo(Plata)', order: 46 },
        { verificado_equipo_descripcion_quipo_texto2: 'Equipo Detalle(Texto)', order: 47 },
        { verificado_equipo_monto_quipo_monto2: 'Equipo Detalle(Plata)', order: 48 },

        { verificado_detalle_servicio_descripcion_pago_texto: 'Servicio(Texto)', order: 49 },
        { verificado_detalle_servicio_descripcion_pago_monto: 'Servicio(Plata)', order: 50 },
        { verificado_detalle_servicio_descripcion_pago_texto2: 'Servicio Detalle(Texto)', order: 51 },
        { verificado_detalle_servicio_descripcion_pago_monto2: 'Servicio Detalle(Plata)', order: 52 },

        { verificado_detalle_servicio_descripcion_caja_menuda_texto: 'Servicio Caja(Texto)', order: 53 },
        { verificado_detalle_servicio_descripcion_caja_menuda_monto: 'Servicio Caja(Plata)', order: 54 },
        { verificado_detalle_servicio_descripcion_caja_menuda_texto2: 'Servicio Caja Det.(Texto)', order: 55 },
        { verificado_detalle_servicio_descripcion_caja_menuda_monto2: 'Servicio Caja Det.(Plata)', order: 56 },

        { verificado_proveedor_texto: 'Proveedor(Texto)', order: 57 },
        { verificado_proveedor_monto: 'Proveedor(Plata)', order: 58 },
        { verificado_proveedor_texto2: 'Proveedor Detalle(Texto)', order: 59 },
        { verificado_proveedor_monto2: 'Proveedor Detalle(Plata)', order: 60 },

        { verificado_cuenta_contable_texto: 'Cta. Cont.(Texto)', order: 61 },
        { verificado_cuenta_contable_monto: 'Cta. Cont.(Plata)', order: 62 },
        { verificado_cuenta_contable_texto2: 'Cta. Cont. Detalle(Texto)', order: 63 },
        { verificado_cuenta_contable_monto2: 'Cta. Cont. Detalle(Plata)', order: 64 },
      ]
    },
  },
  methods: {
    /**
     * @return {HTMLElement}
     */
    initializeAccordion() {
      const accordionDiv = this.createAccordionDiv()
      this.attributeKeys = this.getValueAccordingToKeyAccordion()

      for (const key in this.valuesInsert) {
        const cardDiv = this.createCardDiv(key)
        accordionDiv.appendChild(cardDiv)
      }

      return accordionDiv
    },
    /**
     * @return {HTMLDivElement}
     */
    createAccordionDiv() {
      const accordionDiv = document.createElement('div')
      accordionDiv.setAttribute('class', 'accordion text-left')
      accordionDiv.setAttribute('id', 'requestCoincidencesAccordion')

      return accordionDiv
    },
    /**
     * @param {int} index
     * @return {HTMLDivElement}
     */
    createCardDiv(index) {
      const cardDiv = document.createElement('div')
      cardDiv.setAttribute('class', 'card')

      if (parseInt(index) === 0) {
        cardDiv.setAttribute('style', 'background-color: #e4ecf7')
      }

      const cardHeaderDiv = this.createCardHeaderDiv(index)
      const cardBodyDiv = this.createCardBodyDiv(index)

      cardDiv.appendChild(cardHeaderDiv)
      cardDiv.appendChild(cardBodyDiv)

      return cardDiv
    },
    /**
     * @param {int} indexId
     * @returns {HTMLDivElement}
     */
    createCardHeaderDiv(index) {
      const cardHeaderDiv = document.createElement('div')
      cardHeaderDiv.setAttribute('class', 'card-header')
      cardHeaderDiv.setAttribute('id', `heading${index}`)

      const cardHeaderH2 = document.createElement('h2')
      cardHeaderH2.setAttribute('class', 'mb-0')

      const cardLinkButton = document.createElement('button')
      cardLinkButton.setAttribute('class', 'btn btn-link btn-block text-left font-weight-bold')
      cardLinkButton.setAttribute('type', 'button')
      cardLinkButton.setAttribute('data-toggle', 'collapse')
      cardLinkButton.setAttribute('data-target', `#collapse${index}`)
      cardLinkButton.setAttribute('aria-expanded', 'true')
      cardLinkButton.setAttribute('aria-controls', `#collapse${index}`)

      const textLink = this.createTextLinkHeader(index)
      cardLinkButton.appendChild(textLink)

      cardHeaderH2.appendChild(cardLinkButton)
      cardHeaderDiv.appendChild(cardHeaderH2)

      return cardHeaderDiv
    },
    /**
     * @param {int} index
     * @returns
     */
    createTextLinkHeader(index) {
      const idPosition = this.attributeKeys.indexOf('Id')
      let idString = ''

      if (this.checkVariable(idPosition)) {
        if (this.checkVariable(this.valuesInsert[index][idPosition])) {
          idString = `Solicitud Id ${this.valuesInsert[index][idPosition]},`
        }
      }

      const projectPosition = this.attributeKeys.indexOf('Proyecto')
      let projectString = ''
      if (this.checkVariable(projectPosition)) {
        if (this.checkVariable(this.valuesInsert[index][projectPosition])) {
          projectString = ` Proyecto ${this.valuesInsert[index][projectPosition]},`
        }
      }

      const contractPosition = this.attributeKeys.indexOf('Job')
      let contractString = ''
      if (this.checkVariable(contractPosition)) {
        if (this.checkVariable(this.valuesInsert[index][contractPosition])) {
          contractString = ` ${this.valuesInsert[index][contractPosition]}`
        }

      }

      return document.createTextNode(`${idString}${projectString}${contractString}`)
    },
    /**
     * @param {int} index
     * @returns {HTMLDivElement}
     */
    createCardBodyDiv(index) {
      const showCollapse = parseInt(index) > 0 ? '' : ' show'

      const collapseDiv = document.createElement('div')
      collapseDiv.setAttribute('id', `collapse${index}`)
      collapseDiv.setAttribute('class', `collapse${showCollapse}`)
      collapseDiv.setAttribute('aria-labelledby', `heading${index}`)
      collapseDiv.setAttribute('data-parent', '#requestCoincidencesAccordion')

      const cardBodyDiv = document.createElement('div')
      cardBodyDiv.setAttribute('class', 'card-body')

      const attributesListDl = this.createAttributesListDl(index)
      cardBodyDiv.appendChild(attributesListDl)

      collapseDiv.appendChild(cardBodyDiv)

      return collapseDiv
    },
    /**
     *
     * @param {int} index
     * @returns {HTMLDListElement}
     */
    createAttributesListDl(index) {
      const attributesListDl = document.createElement('dl')
      attributesListDl.setAttribute('class', 'row')

      for (const key in this.attributeKeys) {
        const attributeDt = document.createElement('dt')
        attributeDt.setAttribute('class', 'col-sm-4')
        const textDt = document.createTextNode(this.attributeKeys[key])
        attributeDt.appendChild(textDt)
        attributesListDl.appendChild(attributeDt)

        const attributeDd = document.createElement('dd')
        attributeDd.setAttribute('class', 'col-sm-8')

        if (parseInt(index) === 0 && this.getAmountOfKeys(this.columnAttributesVerified) > 0 && this.checkVariable(this.requestMatchesAccordion)) {
          const verifiedKey = this.columnAttributesVerified[key]
          const match = this.replace(verifiedKey, /to2|to2/, 'to1')
          const newKeysMatches = Object.keys(this.requestMatchesAccordion)
          const newIndex = this.findWith(newKeysMatches, newKey => {
            return newKey === match
          })

          if (this.checkVariable(newKeysMatches[newIndex])) {
            const resultKey = newKeysMatches[newIndex]
            attributeDd.appendChild(document.createTextNode(this.requestMatchesAccordion[resultKey]))
          }
        }

        if (this.attributeKeys[key] === 'Id') {
          const href = this.getModulePathAccordion(this.valuesInsert[index], key)

          if (this.checkVariable(href)) {
            const a = document.createElement('a')
            a.setAttribute('href', this.renderUrlWeb(href))
            a.setAttribute('target', '_blank')
            a.textContent = this.valuesInsert[index][key]
            attributeDd.appendChild(a)
          } else {
            attributeDd.appendChild(document.createTextNode(this.valuesInsert[index][key]))
          }
        } else {
          attributeDd.appendChild(document.createTextNode(this.valuesInsert[index][key]))
        }

        attributesListDl.appendChild(attributeDd)
      }

      return attributesListDl
    },
    /**
     * @param {Array} value
     * @param {int} indexId
     * @return {String}
     */
    getModulePathAccordion(value, indexId) {
      const id = value[indexId]
      if (this.checkVariable(this.findIndex(value, 'Extras'))) {
        return this.$router.resolve({ name: 'extra.show', params: { extra_id: id } }).href
      } else if (this.checkVariable(this.findIndex(value, 'Garantías'))) {
        return this.$router.resolve({ name: 'garantias.show', params: { garantia_id: id } }).href
      } else if (this.checkVariable(this.findIndex(value, 'Materiales'))) {
        return this.$router.resolve({ name: 'showmaterial', params: { material_id: id } }).href
      } else if (this.checkVariable(this.findIndex(value, 'Pagos'))) {
        return this.$router.resolve({ name: 'showpayment', params: { payment_id: id } }).href
      } else if (this.checkVariable(this.findIndex(value, 'Caja menuda'))) {
        return this.$router.resolve({ name: 'tiny_box.show', params: { tiny_box_id: id } }).href
      }

      return ''
    },
    /**
     * @var {Array}
     * @return {Array}
     */
    createBaseObjectAccordion(datos) {
      const columnAttributes = this.sortColumnsAccordion(this.columnAttributes)
      const intMax = this.getAmountOfKeys(columnAttributes)
      const resultValues = []
      for (const currentIndex in datos) {
        let index = 0
        resultValues[currentIndex] = []
        while (index < intMax) {
          if (this.checkVariable(columnAttributes[index])) {
            resultValues[currentIndex][columnAttributes[index]] = null
          }
          index++
        }
      }

      return resultValues
    },
    /**
     * @param {Array} datos
     * @return {Array}
     */
    createDataBody(datos) {
      if (this.checkVariable(datos) && this.isArray(datos)) {
        const rows = this.passInformationByKeyAccordion(datos)
        const intMax = this.getAmountOfKeys(this.sortColumnsAccordion(this.columnAttributes))
        const newRows = []
        rows.forEach(element => {
          const columns = []
          const temp = this.arrayFrom(element)
          let index = 0
          while (index < intMax) {
            if (this.checkVariable(temp[index])) {
              const value = this.isNumber(temp[index]) ? parseInt(temp[index]) : temp[index]
              columns.push(value)
            } else {
              columns.push('')
            }
            index++
          }
          newRows.push(columns)
        })

        return newRows
      }

      return []
    },
    /**
     * @var {Array}
     * @return {Array}
     */
    passInformationByKeyAccordion(datos) {
      if (this.checkVariable(datos) && this.isArray(datos)) {
        const columnAttributes = this.sortColumnsAccordion(this.columnAttributes)
        const rows = this.pluck(datos, columnAttributes)
        const testRows = this.createBaseObjectAccordion(rows)

        return this.mergeWith(
          rows,
          testRows,
          (objValue, srcValue) => {
            if (this.checkVariable(srcValue)) {
              return this.merge(Object.assign({}, srcValue), objValue)
            }
          },
        )
      }

      return []
    },
    /**
     * @param {Array} datos
     * @return {Array}
     */
    sortColumnsAccordion(datos) {
      if (!this.isArray(datos)) {
        return []
      }
      if (this.getAmountOfKeys(datos) === 0) {
        return []
      }
      const columns = []
      const sort = this.kSort(this.verifiedAttributesAccordion, 'order')
      for (const value of sort) {
        const key = this.getTheFirst(this.getKeysObject(value))
        const result = this.findIndex(datos, key)
        if (this.checkVariable(result)) {
          columns.push(result)
        }
      }

      return columns
    },
    getValueAccordingToKeyAccordion() {
      const columns = []
      const columnsIdentifier = []
      const columnAttributes = this.sortColumnsAccordion(this.columnAttributes)
      if (this.isArray(columnAttributes)) {
        for (const column of columnAttributes) {
          const result = this.findIndex(this.verifiedAttributesAccordion, column)
          if (this.checkVariable(result)) {
            columns.push(result)
            columnsIdentifier.push(column)
          }
        }
      }
      this.columnAttributesVerified = columnsIdentifier

      return columns
    },
    /**
     * @param {Object} request
     * @param {Array} verified
     * @return {Array}
     */
    createValidObjectRequestAccordion(request, verified) {
      let contrato = null
      if (this.checkVariable(request.contrato_activo) && this.isObject(request.contrato_activo)) {
        contrato = request.contrato_activo.nombre
      } else if (this.checkVariable(request.contrato) && this.isString(request.contrato)) {
        contrato = request.contrato
      }
      let estadoMaterial = null
      if (this.checkVariable(request.estado_material)) {
        estadoMaterial = request.estado_material.nombre
      }
      let proyecto = null
      if (this.checkVariable(request.proyecto) && this.isObject(request.proyecto)) {
        proyecto = request.proyecto.nombre
      } else if (this.checkVariable(request.proyecto) && this.isString(request.proyecto)) {
        proyecto = request.proyecto
      }
      let tipoSolicitud = null
      if (this.checkVariable(request.tipo_solicitud) && this.isObject(request.tipo_solicitud)) {
        tipoSolicitud = request.tipo_solicitud.nombre
      }
      let cuentaContable = null
      if (this.checkVariable(request.cuenta_contable) && this.isObject(request.cuenta_contable)) {
        cuentaContable = request.cuenta_contable.nombre
      } else if (this.checkVariable(request.cuenta_contable) && this.isString(request.cuenta_contable)) {
        cuentaContable = request.cuenta_contable
      }
      let contratista = null
      if (this.checkVariable(request.contratista_asignado) && this.isObject(request.contratista_asignado)) {
        contratista = request.contratista_asignado.nombre_empresa
      } else if (this.checkVariable(request.proveedor) && this.isObject(request.proveedor)) {
        contratista = request.proveedor.nombre_empresa
      }
      let format = [
        {
          solicitud_id: request.id,
          solicitada: request.user_create_name,
          estado_material: estadoMaterial,
          proyecto,
          tipo_solicitud: tipoSolicitud,
          contrato,
          cuenta_contable: cuentaContable,
          fecha: request.fecha,
          contratista,
          total_solicitud: this.getNumberFormat(request.total_solicitud),
        },
      ]
      if (this.isArray(verified) && verified.length > 0) {
        const data = this.pluck(verified, 'concidencia')
        const coincidences = this.getUniqueWithKeyWithout(data, true, 'texto1\\b|monto1\\b')
        this.requestMatchesAccordion = coincidences

        return [this.merge(format[0], coincidences)]
      }

      return format
    },
    /**
     * @param {Array}
     * @return {HTMLTableElement}
     */
    menuSubmitVerifiedAccordion(verified) {
      const newData = this.pluck(verified, 'concidencia')
      const originalColumns = this.getKeys(newData, true)
      this.insertArray(newData, 0, this.getTheFirst(this.currentRequestAccordion))

      this.columnAttributes = originalColumns
      this.valuesInsert = this.createDataBody(newData)

      return this.initializeAccordion()
    },
    /**
     * @param {Object} request
     * @param {Array} verified
     */
    exportAccordion(request, verified) {
      this.currentRequestAccordion = this.createValidObjectRequestAccordion(request, verified)
      const accordion = this.menuSubmitVerifiedAccordion(verified)

      return accordion
    },
  },
}

const Component = Vue.extend({
  name: 'new-accordion',
  mixins: [accordionMixin],
})

export default Component
